module.exports = __webpack_public_path__ + "static/media/stevie-registration-bg.6a1497dd.png";